import styled from '@emotion/styled'

export const ScormWrapper = styled.div<{ inModal: boolean }>`
  ${({ inModal }) =>
    inModal
      ? 'position: fixed; left: 0; top: 0; z-index: 1000; height: 100vh; width: 100vw;'
      : ''}
`
